<template>
    <div class="text-center">
        <div style="width: 3rem; height: 3rem;" class="spinner-grow d-inline-block my-5" />
    </div>
</template>
